import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { TrainingMembershipFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import Page from 'modules/layout/components/Page'
import Header from 'modules/layout/components/Page/Header'
import { Detail } from 'modules/trainings/components/MyTrainings/Detail'
import { useSessionFilesContext } from 'modules/trainings/hooks/SessionFiles/useSessionFilesContext'
import { useTrainingFilesContext } from 'modules/trainings/hooks/TrainingFiles/useTrainingFilesContext'
import { useTrainingsContext } from 'modules/trainings/hooks/Trainings/useTrainingsContext'

const TrainingDetail = () => {
  const { id, trainingId } = useParams()
  const { trainings } = useTrainingsContext()
  const { employeeId, employeeAccessId, trainingMemberships } = useOutletContext<{
    employeeId?: number
    employeeAccessId?: number
    trainingMemberships: TrainingMembershipFragment[]
  }>()
  const { navigation } = useNavigation()

  const { trainingFiles } = useTrainingFilesContext()
  const { sessionFiles } = useSessionFilesContext()

  if (!employeeId || !employeeAccessId) {
    throw new Error('Employee ID and access ID are required')
  }

  return (
    <Page>
      <Page.Header>
        <Header.Title backTo={navigation.employees.id.training.fullPath({ id: String(id) })}>
          {i18n.t('trainings.trainings_detail.title')}
        </Header.Title>
      </Page.Header>
      <Page.Body>
        <Box width="full">
          <Box paddingX="s48" paddingY="s24">
            <Detail
              fileNavigation={(fileId) =>
                navigation.employees.id.training.detail.view.fileViewer.fullPath({
                  id: String(id),
                  trainingId: String(trainingId),
                  trainingFileId: fileId,
                })
              }
              sessionModalTo={(sessionId) =>
                navigation.employees.id.training.detail.view.sessionDetail.fullPath({
                  id: String(id),
                  trainingId: String(trainingId),
                  sessionId: sessionId,
                })
              }
              accessId={employeeAccessId}
              employeeId={employeeId}
              uploadCertificateTo={(trainingId) => {
                return navigation.employees.id.training.detail.view.certificates.upload.fullPath({
                  id: String(id),
                  trainingId: String(trainingId),
                })
              }}
            />
            <Outlet
              context={{
                employeeId,
                employeeAccessId,
                trainings,
                trainingFiles,
                sessionFiles,
                trainingMemberships,
              }}
            />
          </Box>
        </Box>
      </Page.Body>
    </Page>
  )
}

export default TrainingDetail
